module.exports = __webpack_public_path__ + "img/times-circle.693ac379.svg";